import React,{useState} from 'react'
import Modal from '../../../components/Modal'

export default function BroadcastModal({setModal,onClick}) {

  return (
    <Modal title="Broadcast Enquiry" size="md">
        <div className="modal-inner-content">
            <p className="r-text m-weight f-op">Are you sure you want to broadcast for this enquiry?</p>
        </div>
        <div className="modal-footer">
            <button className="xs-neutral-btn" onClick={()=>setModal(false)}>Cancel</button>
            <button className="xs-delete-btn" onClick={()=>onClick()}>Broadcast now</button>
        </div>
    </Modal>
  )
}
